import dayjs from 'dayjs';
import VueI18n, { TranslateResult } from 'vue-i18n';

import { useStore } from '../composables/store.composable';

import Locale from '../models/utilities/locale.model';

import { LANG_DIRECTION, RTL_LANGUAGES } from '../models/constants';

export const i18n = new VueI18n({
  missing: () => '',
  silentTranslationWarn: true,
});

export class TranslationService {
  static async setLocale(locale: Locale): Promise<void> {
    const { commit } = useStore();

    TranslationService.setDirection(locale.language);

    import(`dayjs/locale/${locale.language}.js`).then(() => {
      dayjs.locale(locale.language);
    });
    await commit('locale', locale);
  }

  // eslint-disable-next-line
  static setI18nLanguage(lang: string): string {
    // eslint-disable-next-line
    document.querySelector('html')!.setAttribute('lang', lang);
    return lang;
  }

  // eslint-disable-next-line
  static loadLocale(lang: string, dictionary: any): string {
    i18n.locale = lang;
    i18n.setLocaleMessage(lang, dictionary);
    return TranslationService.setI18nLanguage(lang);
  }

  static setDirection(lang: string): void {
    const { commit } = useStore();

    const dir = RTL_LANGUAGES.some((l) => l === lang)
      ? LANG_DIRECTION.RTL
      : LANG_DIRECTION.LTR;

    commit('direction', dir);
  }

  static translateOption(
    type: string,
    option: string | undefined,
    convertToLowerCase = true
  ): string | TranslateResult {
    let label = `shared.${type}.${option}`;
    label = convertToLowerCase ? label.toLowerCase() : label;

    return i18n.t(label);
  }
}
